import { inject, Injectable } from '@angular/core';
import { urlJoin } from '../../../../core/helpers/url.helper';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../../app.config';
import { Observable, tap } from 'rxjs';
import { DocumentHistoryResponse } from './documents-model';
import { LogService } from '../../../../core/services/log/log.service';
import { createHeadersWithGlobalUuid } from '@tribeauto/ngx-mobilite-material';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
  private readonly httpClient = inject(HttpClient);
  private readonly appConfig = inject(AppConfig);
  private readonly logService = inject(LogService);

  private readonly url = urlJoin(this.appConfig.url, 'document');

  getDocumentHistory(webstoreId: string, contractId: string): Observable<DocumentHistoryResponse[]> {
    return this.httpClient
      .get<DocumentHistoryResponse[]>(urlJoin(this.url, 'webstores', webstoreId, 'contracts', contractId, 'history'), {
        headers: createHeadersWithGlobalUuid(this.logService.sessionUuid())
      })
      .pipe(
        tap(documents => {
          for (const doc of documents) {
            doc.sendDate = new Date(doc.sendDate);
          }
        })
      );
  }

  getDownloadDocumentById(webstoreId: string, contractId: string, documentId: string): Observable<ArrayBuffer> {
    return this.httpClient.get(
      urlJoin(this.url, 'webstores', webstoreId, 'contracts', contractId, 'download', documentId),
      { headers: createHeadersWithGlobalUuid(this.logService.sessionUuid()), responseType: 'arraybuffer' as const }
    );
  }
}
